import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { SaveEditModeChangesComponent } from '@connect-services/client/components/save-edit-mode-changes/save-edit-mode-changes.component';
import { SaveEditModeResultEnum } from '@connect-services/client/models/common.model';

export type EditModeSaveHandler = () => void | Promise<void>;

export interface EditModeConfirmationContext {
    canEndEditSession: boolean;
    onSaved?: EditModeSaveHandler;
}
@Injectable({
    providedIn: 'root',
})
export class EditModeConfirmationService {
    private readonly dialog = inject(MatDialog);

    public openSaveChangesModal(
        data: EditModeConfirmationContext,
    ): MatDialogRef<SaveEditModeChangesComponent, SaveEditModeResultEnum> {
        return this.dialog.open(SaveEditModeChangesComponent, {
            data,
            restoreFocus: false,
            width: '36rem',
        });
    }
}
